var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.184,
    height: 18.888,
    viewBox: "0 0 25.184 18.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M1316.823,998.443h-20.462A2.363,2.363,0,0,0,1294,1000.8v14.166a2.363,2.363,0,0,0,2.361,2.361h20.462a2.363,2.363,0,0,0,2.361-2.361V1000.8A2.363,2.363,0,0,0,1316.823,998.443Zm0,1.574a.8.8,0,0,1,.3.061l-10.533,9.129-10.532-9.129a.792.792,0,0,1,.3-.061Zm0,15.74h-20.462a.787.787,0,0,1-.787-.787v-13.229l10.5,9.1a.789.789,0,0,0,1.032,0l10.5-9.1v13.229A.787.787,0,0,1,1316.823,1015.757Z",
    transform: "translate(-1294 -998.443)",
    fill: "#840094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.8d5570ce38e03311c9b9bc07c16e3f95.svg";
export { ForwardRef as ReactComponent };